export default __webpack_public_path__ + "static/media/Snd_ClowerM.ce71d495.mp3";